{
  "cms.videoListing.field.title": "Otsikko",
  "cms.videoListing.field.video": "Video",
  "cms.videoListing.field.url": "URL",
  "cms.videoListing.field.body": "Lisätietoja (näkyy haitarissa)",
  "cms.videoListing.error.titleRequired": "Otsikko on pakollinen (enintään 200 merkkiä).",
  "cms.videoListing.error.titleNotDerivable": "Otsikossa on oltava vähintään yksi latinalainen kirjain tai numero.",
  "cms.videoListing.error.videoUrlHttps": "Anna videolle https://-linkki tai lataa videotiedosto."
}
